import React, { useState, useEffect } from "react";
import { Download, ArrowRight } from "lucide-react";
import Image from "../../../components/AppImage";
// VERIFIEZ BIEN CE CHEMIN :
import CatalogDownloadModal from "../../../components/ui/CatalogDownloadModal";

const CAROUSEL_IMAGES = [
{ src: "/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png", alt: "CRF Perfection Logo", isLogo: true },
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_16065c62c-1769391962468.png", alt: "Formation professionnelle et développement des compétences", isLogo: false }];


const TYPEWRITER_TEXTS = ["Formation Professionnelle", "Conseil Stratégique", "Événements COPAF 2026", "Capital Humain"];

const HeroSection = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [textIndex, setTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // État pour le Modal

  // --- Gestion du Carousel ---
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => prev === CAROUSEL_IMAGES?.length - 1 ? 0 : prev + 1);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // --- Gestion du Typewriter ---
  useEffect(() => {
    const currentFullText = TYPEWRITER_TEXTS?.[textIndex];
    const speed = isDeleting ? 30 : 60;
    const timeout = setTimeout(() => {
      if (!isDeleting && displayedText === currentFullText) {
        setTimeout(() => setIsDeleting(true), 2500);
      } else if (isDeleting && displayedText === "") {
        setIsDeleting(false);
        setTextIndex((prev) => (prev + 1) % TYPEWRITER_TEXTS?.length);
      } else {
        const nextText = isDeleting ?
        currentFullText?.substring(0, displayedText?.length - 1) :
        currentFullText?.substring(0, displayedText?.length + 1);
        setDisplayedText(nextText);
      }
    }, speed);
    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, textIndex]);

  return (
    <section className="relative min-h-[85vh] flex items-center bg-[#0B121E] text-white overflow-hidden py-16">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#9B8E57]/10 blur-[120px] -z-0 translate-x-1/3 -translate-y-1/3" />
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          <div className="lg:col-span-7 space-y-8 text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 px-4 py-1.5 bg-white/5 border border-white/10 rounded-full">
              <span className="w-2 h-2 bg-[#9B8E57] rounded-full animate-pulse"></span>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400">L'Excellence en Marche</span>
            </div>

            <div className="space-y-4">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight">
                Forger les <br /> <span className="text-[#9B8E57]">Leaders</span> de demain
              </h1>
              <div className="min-h-[30px] flex justify-center lg:justify-start">
                <p className="text-[#9B8E57] font-medium text-lg md:text-xl">
                  {displayedText}<span className="ml-1 border-r-2 border-white animate-blink"></span>
                </p>
              </div>
            </div>

            <p className="text-gray-400 text-base max-w-xl mx-auto lg:mx-0 leading-relaxed font-light">
              Des solutions sur mesure pour développer vos compétences et propulser votre entreprise vers le succès.
            </p>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 pt-4">
              {/* BOUTON MODIFIÉ ICI */}
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-[#9B8E57] text-white px-8 py-4 rounded-xl font-bold text-sm flex items-center justify-center space-x-3 hover:bg-[#8A7D4B] transition-all">

                <Download size={18} />
                <span>Télécharger le catalogue</span>
              </button>
              
              <a href="/services" className="bg-[#A1171E] text-white px-8 py-4 rounded-xl font-bold text-sm flex items-center justify-center space-x-2 hover:bg-white hover:text-[#A1171E] transition-all">
                <span>Démarrer un projet</span>
                <ArrowRight size={18} />
              </a>
            </div>
          </div>

          {/* Carousel à droite */}
          <div className="lg:col-span-5 relative flex justify-center">
            <div className="relative w-full max-w-[450px] aspect-[4/5] rounded-[2rem] overflow-hidden border border-white/10 bg-[#151C29] p-12">
              {CAROUSEL_IMAGES?.map((img, index) =>
              <div key={index} className={`absolute inset-0 p-10 flex items-center justify-center transition-all duration-1000 ${index === currentImage ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
                  <Image src={img?.src} alt={img?.alt} className={img?.isLogo ? 'object-contain' : 'object-cover rounded-2xl w-full h-full'} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* MODAL (S'assure qu'il est bien rendu ici) */}
      <CatalogDownloadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        catalogUrl="https://drive.google.com/file/d/1C3SLPOPkvPjhiw_z7v8xHLfjEJKAsBhO/view?usp=sharing" />

      <style jsx>{`
        @keyframes blink { 50% { border-color: transparent; } }
        .animate-blink { animation: blink 0.7s step-end infinite; }
      `}</style>
    </section>);

};

export default HeroSection;